import ApiService from '../../services/api.service'
import { Notify } from 'quasar'

// Promesse en cours pour éviter 2 requêtes simultanées (ex. FormAddModuleFormation + ModuleFormationContent)
let pendingFetchPromise = null

export const schedulerActivities = {
  // *** C'est l'endroit où vous stockez les données.
  // ** On accède à l'état en utilisant ``this.$store.state`` dans les composants Vue, ou via ``mapState`` dans l'option ``computed``.
  state: {
    schedulerActivities: [],
    schedulerActivity: null,

    liaisonActions: [],
    liaisonAction: null
  },
  // *** Fonctions synchrones qui modifient l'état du store. Elles sont le seul moyen de modifier l'état.
  // ** On invoque une mutation en appelant ``commit`` dans les composants Vue.
  mutations: {
    setSchedulerActivities(state, schedulerActivities) {
      state.schedulerActivities = schedulerActivities
    },
    setSchedulerActivity(state, schedulerActivity) {
      state.schedulerActivity = schedulerActivity
    },

    setLiaisonActivities(state, liaisonActions) {
      state.liaisonActions = liaisonActions
    },
    setLiaisonActivity(state, liaisonAction) {
      state.liaisonAction = liaisonAction
    },

    //Callbacks
    callbackAddSchedulerActivity(state, newActivity) {
      state.schedulerActivities.push(newActivity)

      // Met à jour le tableau des intervenants associé à cette activité
      // const speakerIds = newActivity.speakers.map(speaker => speaker.id);
      // context.commit('schedulerSpeakers/callbackAddSchedulerActivityToSpeakers', { activity: newActivity, speakers: speakerIds }, { root: true });
    },
    callbackUpdateSchedulerActivity(state, updatedActivity) {
      const index = state.schedulerActivities.findIndex(
        (activity) => activity.id === updatedActivity.id
      )
      if (index !== -1) {
        state.schedulerActivities.splice(index, 1, updatedActivity)
      }
    },
    callbackRemoveSchedulerActivity(state, activityId) {
      for (var activity in state.schedulerActivities) {
        if (state.schedulerActivities[activity].id == activityId) {
          state.schedulerActivities.splice(activity, 1)
        }
      }
    }
  },
  // *** Fonctions qui peuvent être asynchrones et effectuer des opérations asynchrones, telles que les appels API, puis invoquer des mutations pour modifier l'état en conséquence.
  // ** On invoque une action en appelant ``dispatch`` dans les composants Vue.
  actions: {
    // GET :: Récupère la listes des activités
    fetchAllSchedulerActivities(context, antenneId = null) {
      // Déjà en cache (sans filtre antenne)
      if (!antenneId && context.state.schedulerActivities.length > 0) {
        return Promise.resolve()
      }
      // Une requête est déjà en cours (sans filtre) : réutiliser la même promesse → une seule requête réseau
      if (!antenneId && pendingFetchPromise) {
        return pendingFetchPromise
      }
      let url = '/scheduler_activities'
      if (antenneId) {
        url += `?antenne=${antenneId}`
      }
      const promise = ApiService.getRequest(url)
        .then((response) => {
          context.commit(
            'setSchedulerActivities',
            response.data['hydra:member']
          )
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message: "Une erreur s'est produite",
            color: 'red'
          })
        })
        .finally(() => {
          if (!antenneId) pendingFetchPromise = null
        })
      if (!antenneId) pendingFetchPromise = promise
      return promise
    },
    //GET :: Récupere les activité par id
    async fetchScheSchedulerActivity(context, idActivity) {
      return ApiService.getRequest(idActivity)
        .then((response) => {
          context.commit('setSchedulerActivity', response.data)
          context.commit('setSchedulerActivities', response.data)
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message: "Une erreur s'est produite",
            color: 'red'
          })
        })
    },
    // POST :: Ajoute une nouvelle activité
    async addSchedulerActivity(context, newActivity) {
      try {
        const response = await ApiService.postRequest(
          '/scheduler_activities',
          newActivity
        )
        context.commit('setSchedulerActivity', response.data)
        if (response.status === 201) {
          context.commit('callbackAddSchedulerActivity', response.data)

          // Met à jour le store schedulerSpeakers
          const speakerIds = (response.data.speakers || []).map((speaker) => speaker.id)
          context.dispatch('addSchedulerActivityToSpeakers', {
            activity: response.data,
            speakers: speakerIds
          })

          Notify.create({
            message: 'Le module de formation a été ajoutée avec succès.',
            color: 'green'
          })
          return Promise.resolve()
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },
    // PUT :: Met à jour une activité
    async updateSchedulerActivity(context, updatedActivity) {
      try {
        const response = await ApiService.patchRequest(
          `/scheduler_activities/${updatedActivity.id}`,
          updatedActivity
        )
        if (response.status === 200) {
          context.commit('callbackUpdateSchedulerActivity', updatedActivity)
          // Met à jour le store schedulerSpeakers
          context.dispatch('updateSchedulerActivityInSpeakers', updatedActivity)

          Notify.create({
            message: 'Le module de formation a été mis à jour avec succès.',
            color: 'green'
          })
          return Promise.resolve()
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },
    // DELETE :: Supprime une activité
    async removeSchedulerActivity(context, activityId) {
      try {
        const response = await ApiService.deleteRequest(
          `/scheduler_activities/${activityId}`
        )
        if (response.status === 204) {
          context.commit('callbackRemoveSchedulerActivity', activityId)
          Notify.create({
            message: 'Le module de formation a été supprimé avec succès.',
            color: 'green'
          })
          return Promise.resolve()
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },

    //********* Requetes  des liaison entre les activités et les actions de formation  **********************

    async addLiaisonActivityFormation(context, formData) {
      try {
        const response = await ApiService.postRequest(
          'scheduler_activity_action_formations',
          formData
        )
        context.commit('setLiaisonActivity', response.data)
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout du modèle",
          color: 'red'
        })
      }
    },
    async editLiaisonActivityFormation(context, data) {
      try {
        const response = await ApiService.postRequest(
          `${data.url}`,
          data.formData
        )
        context.commit('setLiaisonActivity', response.data)
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite lors de la suppression.",
          color: 'red'
        })
      }
    },
    removeLiaisonActivityFormation(context, liaison) {
      try {
        ApiService.deleteRequest(liaison)
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite lors de la suppression.",
          color: 'red'
        })
      }
    }
  },
  getters: {
    getSchedulerActivities(state) {
      return state.schedulerActivities
    },
    getSchedulerActivity(state) {
      return state.schedulerActivity
    },

    getLiaisonActivities(state) {
      return state.liaisonActions
    },
    getLiaisonActivity(state) {
      return state.liaisonAction
    }
  }
}
